const { effect, signal } = require('@node_modules/@preact/signals-core');
const QBreadcrumbMenu = require('./q-breadcrumb-menu');
const QBreadcrumbQuickAccess = require('./q-breadcrumb-quick-access');

function QBreadCrumbMegaMenu(props) {
    let timer;
    const breadCrumbElement = props.breadCrumbElement;
    const scrollableContent = props.scrollableContent;
    const plainItems = props.plainItems;
    const useTitleConfig = props.useTitleConfig;
    const sections = props.sections;
    const shouldUpdate = props.shouldUpdate;
    const currentActiveMenu = signal(plainItems[0]);
    const currentActiveItems = signal([]);
    const homeItem = QBreadcrumbMenu.prototype._createHomeItem.call(undefined, props.homeRoute);
    const quickAccess = QBreadcrumbQuickAccess(sections, props.events);

    breadCrumbElement.append(homeItem, quickAccess);

    scrollableContent.on('scroll', () => {
        KTUtil.throttle(timer, () => {
            currentActiveMenu.value = plainItems.find(menuItem => {
                if (menuItem._inTreeview) {
                    return treeviewSubSectionInViewPort(menuItem, scrollableContent);
                }

                return isInViewport(scrollableContent, menuItem._megaMenu.menuElement)
            });
        }, 200);
    });

    effect(() => { // on search
        currentActiveMenu.value = plainItems.find(item => item.isVisible.value);
    });

    effect(() => {
        shouldUpdate.value; // subscribe to shouldUpdate changes

        const activeItems = activeItem(currentActiveMenu.value).filter(e => e._megaMenu);
        const current = currentActiveItems.peek();

        if ((current.length != activeItems.length) || hasSameItems(current, activeItems)) {
            currentActiveItems.value = activeItems;
        }
    });


    effect(() => {
        const items = [];
        
        currentActiveItems.value.forEach((item) => { 
            if (item._parent) {
                if (item._parent.withTreeview) return;

                if (useTitleConfig) {
                    const itemIndex = item._parent.items.indexOf(item);
                    const itemWithTitle = item._parent.items.slice(0, itemIndex + 1).toReversed().find((previousItem) => previousItem.title);
                    
                    if (itemWithTitle) {
                        const titleIndex = item._parent.items.indexOf(itemWithTitle);
                        const dropdownItems = [];
                        
                        for(let index = titleIndex; index < item._parent.items.length; index++) {
                            if (index != titleIndex && item._parent.items[index].title) break;

                            dropdownItems.push(item._parent.items[index]);
                        }

                        const titleEl = createItem(itemWithTitle, item._parent.items.filter(item => item.title), { text: 'title', megaMenuElement: 'titleElement' });
                        const itemEl = createItem(item, dropdownItems, { text: 'caption', megaMenuElement: 'subSectionElement' });
                        
                        items.push(titleEl);
                        items.push(itemEl);
                    }
                    else {
                        const itemEl = createItem(item, item._parent.items, { text: 'caption', megaMenuElement: 'subSectionElement' });
                        
                        items.push(itemEl);
                    }
                }
                else {
                    const itemEl = createItem(item, item._parent.items, { text: 'caption', megaMenuElement: 'subSectionElement' });
                            
                    items.push(itemEl);
                }
            }
            else {
                const itemEl = createItem(item, sections, { text: 'caption', megaMenuElement: 'sectionElement'});

                items.push(itemEl);
            }
        });
        
        breadCrumbElement.children().each((index, item) => {
            if (index > 1) item.remove();
        });

        breadCrumbElement.append(items);
    });
}

function treeviewSubSectionInViewPort(menuItem, scrollableContent) {
    let item = menuItem;

    while(item._parent && !(item._megaMenu && !item._megaMenu.menuElement)) { item = item._parent }

    return isInViewport(scrollableContent, item._megaMenu.subSectionElement || item._megaMenu.titleElement || item._megaMenu.sectionElement);
}

function isInViewport(scrollableContent, element) {
    const rect = element.get(0).getBoundingClientRect();
    const scrollableContentTop = scrollableContent.get(0).getBoundingClientRect().top;

    return (rect.top + element.height() - scrollableContentTop) > 5; // "5" for some tolerance
}

function activeItem(item) {
    if (!item) return [];

    if (item._parent) {
        if (!item.items) return activeItem(item._parent);

        return [...activeItem(item._parent), item];
    }

    return [item];
}

function hasSameItems(currentItems, newItems) {
    return currentItems.find((currentItem, index) => currentItem != newItems[index]);
}

function createItem(item, dropdownItems, propNames) {
    const el = $(/*html*/`<li class="breadcrumb-item">
        <div class="dropdown dropdown-inline">
            <a class="btn btn-sm dropdown-toggle py-2 px-1 font-size-h3" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true">${item[propNames.text || 'caption']}</a>
            <div class="dropdown-menu dropdown-menu-left p-0" x-placement="bottom-end">
                <div class="card card-custom show-limited">
                    <div class="card-body px-0 py-2">
                        <div class="navi custom-scrollbar"></div>
                    </div>
                </div>
            </div>
        </div>
    </li>`);

    if (dropdownItems) {
        const dropdownContent = el.find('.dropdown-menu div.custom-scrollbar');
        const showMore = createShowMoreButton();
        const showLess = createShowLessButton(dropdownItems)
      
        if (!dropdownContent.children().length) {
            const itemsEl = dropdownItems.map((dropdownItem) => createDropwdownItem(dropdownItem, item == dropdownItem, propNames));

            dropdownContent.append(itemsEl, showMore, showLess);
        }

        QBreadcrumbMenu.prototype._fixDropdownPositioning.call(undefined, el);
    }

    return el;
}

function createDropwdownItem (item, isActive, propNames) {
    const itemEl = itemTemplate(item, isActive, propNames);
    
    itemEl.on('click', (e) => {
        e.preventDefault();
        
        item._megaMenu[propNames.megaMenuElement].get(0).scrollIntoView();
    });
    
    return itemEl;
}

function itemTemplate(item, isActive, propNames) {
    return $(/*html*/
    `<div class="navi-item" >
        <a href="#" class="navi-link h-100 ${isActive ? 'active' : ''}">
            <span class="navi-text flex-grow-0 text-line-clamp">${item[propNames.text]}</span>
            <span class="navi-label"></span>
        </a>
    </div>`
    );
}

function createShowMoreButton() {
    const item = itemTemplate({ caption: 'VER TODOS' }, false, { text: 'caption' });

    return item
        .addClass('show-more-items')
        .on('click', (event) => {
            event.stopPropagation();

            item
                .closest('.card')
                .addClass('show-all')
                .removeClass('show-limited');
        });
}

const createShowLessButton = (items) => {
    const item = $(/*html*/
        `<div class="navi-item ${items.length < 17 ? 'd-none' : ''}">
            <a href="#" class="navi-link">
                <span class="navi-text flex-grow-0 text-line-clamp text-primary"><b>ver menos</b></span>
                <span class="navi-label ml-1 "><i class="las la-times text-primary"></i></span>
            </a>
        </div>`
    );

    return item.on('click', (event) => {

        event.stopPropagation();

        item.closest('.card')
            .removeClass('show-all')
            .addClass('show-limited')
    });
};

if (typeof module !== 'undefined') {
    module.exports = QBreadCrumbMegaMenu;
}